import type { DataExplorerViewItemShellProps } from './types';
import { cn } from './utils';

export function DataExplorerViewItemShell({
  media,
  title,
  description,
  meta,
  badges,
  actions,
  footer,
  children,
  className,
  classNames,
}: DataExplorerViewItemShellProps) {
  const hasHeader =
    !!title || !!description || !!meta || !!badges || !!actions;

  return (
    <article
      className={cn(
        'flex min-w-0 flex-col overflow-hidden rounded-lg border border-border/60 bg-background',
        classNames?.root,
        className,
      )}
    >
      {media ? (
        <div className={cn('shrink-0 overflow-hidden', classNames?.media)}>
          {media}
        </div>
      ) : null}

      {hasHeader ? (
        <div className={cn('flex flex-col gap-3 p-4', classNames?.header)}>
          <div className="flex items-start justify-between gap-3">
            <div className="min-w-0 flex-1">
              {title ? (
                <div
                  className={cn(
                    'truncate text-sm font-semibold text-foreground',
                    classNames?.title,
                  )}
                >
                  {title}
                </div>
              ) : null}

              {description ? (
                <div
                  className={cn(
                    'mt-1 text-sm text-muted-foreground',
                    classNames?.description,
                  )}
                >
                  {description}
                </div>
              ) : null}
            </div>

            {(meta || actions) ? (
              <div className="flex shrink-0 items-center gap-2">
                {meta ? (
                  <div className={cn('text-sm text-muted-foreground', classNames?.meta)}>
                    {meta}
                  </div>
                ) : null}

                {actions ? (
                  <div className={cn('flex items-center gap-2', classNames?.actions)}>
                    {actions}
                  </div>
                ) : null}
              </div>
            ) : null}
          </div>

          {badges ? (
            <div className={cn('flex flex-wrap items-center gap-2', classNames?.badges)}>
              {badges}
            </div>
          ) : null}
        </div>
      ) : null}

      {children ? (
        <div className={cn('min-w-0 px-4 pb-4', classNames?.body)}>{children}</div>
      ) : null}

      {footer ? (
        <div className={cn('shrink-0 border-t border-border/60 px-4 py-3', classNames?.footer)}>
          {footer}
        </div>
      ) : null}
    </article>
  );
}
